export const TABS = [
  {
    id: 0,
    label: 'All',
    key: 'all',
    showCount: true,
  },
  {
    id: 1,
    label: 'Approved accounts',
    key: 'approved',
    showCount: true,
  },
  {
    id: 2,
    label: 'Under review',
    key: 'under_review',
    showCount: true,
  },
  {
    id: 3,
    label: 'Flagged',
    key: 'flagged',
    showCount: true,
  },
  {
    id: 4,
    label: 'Declined',
    key: 'declined',
    showCount: true,
  },
  {
    id: 5,
    label: 'Deleted',
    key: 'deleted',
    showCount: true,
  },
];
